import { render, staticRenderFns } from "./BtnWithShadow.vue?vue&type=template&id=2d59790c&scoped=true"
import script from "./BtnWithShadow.vue?vue&type=script&lang=js"
export * from "./BtnWithShadow.vue?vue&type=script&lang=js"
import style0 from "./BtnWithShadow.vue?vue&type=style&index=0&id=2d59790c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d59790c",
  null
  
)

export default component.exports